import { NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { CdkDragHandle } from '@angular/cdk/drag-drop';
import { AiChatWindowTitleBarComponent } from './ai-chat-window-title-bar';
import { initializeAiChatTranslations } from '@panaya/ai-chat/utils';
import { AiChatLayout } from '@panaya/ai-chat/shared';

@Component({
    standalone: true,
    selector: 'p-ai-chat-window',
    imports: [AiChatWindowTitleBarComponent, NgIf, CdkDragHandle],
    templateUrl: './ai-chat-window.component.html',
    styleUrls: ['./ai-chat-window.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AiChatWindowComponent {
    @Input() public showTitleBar = true;
    @Input() isDraggable: boolean = false;
    @Input() isAssistantWorking: boolean = false;
    @Input() currentLayout: AiChatLayout = 'floating';
    /** `true` while an agent has a canvas open; enables the Canvas option of the layout picker. */
    @Input() canvasAvailable = false;
    @Output() layoutChange = new EventEmitter<AiChatLayout>();

    constructor() {
        initializeAiChatTranslations();
    }
}
